export const getAllNews = async () => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/projects/api/news/list`,
      {
        method: 'GET'
      }
    )
    return await response.json()
  } catch (error) {
    throw error
  }
}
